import { Padrao } from '../generic/padrao';

export class ModeloAdendo extends Padrao{

    override idTab = 212;

    nome: string;
}
